<template>
  <BaseModal
    :title="
      $t('message.pages.subtitleEditor.title', {
        lang: currentLangLabel,
      })
    "
    hookSufix="SubtitleContent"
    modalWidth="1360px"
    minHeight="688px"
    :disableDefaultPadding="true"
    :onOpenHook="handleCheckOpen"
    :onCloseHook="handleResetClose"
    :persistent="loadings.updatingSubtitle"
    :bordered="true"
    :borderedToolbar="true"
    preCloseHook="SubtitleContentBeforeClose"
  >
    <template #content>
      <v-container class="pa-0 ma-0 d-flex container__wrapper flex-column">
        <v-row no-gutters class="container__wrapper--sub">
          <v-col>
            <div class="container__vtt-list" no-gutters v-if="parsedSubtitle">
              <vue-virtual-table
                v-if="parsedSubtitle.length > 0"
                ref="dataTableContent"
                class="data-table__content"
                :class="{ virtualTable: $vuetify.theme.dark }"
                :config="tableConfig"
                :data="parsedSubtitleWithHeightProp"
                :height="665"
                :minWidth="455"
                :itemHeight="120"
                :bordered="false"
                :hoverHighlight="false"
                :plusHeight="20"
                style="position: relative; z-index: 1"
              >
                <template slot-scope="scope" slot="rowCommon">
                  <div class="subtitle-item">
                    <div
                      class="d-flex align-start px-6 py-4"
                      :class="{
                        'selected-item': scope.row.selected,
                      }"
                    >
                      <div class="d-flex align-center">
                        <div class="d-flex flex-column container__time-info">
                          <div
                            class="d-flex font-weight-medium text-subtitle-2 time-field align-end pointer"
                            :class="{
                              'brand--text': scope.row.metadata.selected,
                            }"
                          >
                            <v-input
                              :placeholder="
                                isLongerThanAnHour ? '00:00:00' : '00:00'
                              "
                              :value="
                                getSecondsFormatedAsTime(
                                  parsedSubtitle[scope.index].startTime,
                                  isLongerThanAnHour
                                )
                              "
                              :maxlength="isLongerThanAnHour ? 8 : 5"
                              :class="{
                                long: isLongerThanAnHour,
                                'red-outline': verifyTime(scope.row),
                              }"
                              class="time-input"
                              v-mask="isLongerThanAnHour ? '##:##:##' : '##:##'"
                              :hide-details="true"
                              @blur="
                                (event) =>
                                  handleSaveInputTimeInfo(
                                    event.target.value,
                                    'startTime',
                                    scope.index
                                  )
                              "
                            ></v-input>
                          </div>
                          <div
                            class="font-weight-medium text-subtitle-2 time-field align-end pointer mt-2"
                            :class="{
                              'brand--text': scope.row.metadata.selected,
                            }"
                          >
                            <v-input
                              :placeholder="
                                isLongerThanAnHour ? '00:00:00' : '00:00'
                              "
                              :value="
                                getSecondsFormatedAsTime(
                                  parsedSubtitle[scope.index].endTime,
                                  isLongerThanAnHour
                                )
                              "
                              :maxlength="isLongerThanAnHour ? 8 : 5"
                              :class="{
                                long: isLongerThanAnHour,
                                'red-outline': verifyTime(scope.row),
                              }"
                              class="time-input"
                              v-mask="isLongerThanAnHour ? '##:##:##' : '##:##'"
                              :hide-details="true"
                              @blur="
                                (event) =>
                                  handleSaveInputTimeInfo(
                                    event.target.value,
                                    'endTime',
                                    scope.index
                                  )
                              "
                              @keydown.enter="$event.target.blur()"
                            ></v-input>
                          </div>
                        </div>
                      </div>
                      <v-textarea
                        v-model="parsedSubtitle[scope.index].text"
                        :value="parsedSubtitle[scope.index].text"
                        class="subtitle-textarea ml-2"
                        :placeholder="
                          $i18next.t(
                            'message.pages.welcomePanda.actions.insertHere'
                          ) + '...'
                        "
                        :no-resize="true"
                        height="88px"
                        hide-details
                        @blur="updateTextareaEdit(scope.index)"
                        @keydown="preventEnterAction"
                      ></v-textarea>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <BaseBtn
                            v-on="on"
                            v-bind="attrs"
                            type="danger"
                            @click="deleteSubtitlePart(scope.index)"
                            size="xsmall"
                            class="delete-sub hidden"
                          >
                            <v-icon size="16px" style="margin-bottom: 2px">
                              panda-remove
                            </v-icon>
                          </BaseBtn>
                        </template>
                        <span>{{
                          $t('message.pages.subtitleEditor.tooltips.delete')
                        }}</span>
                      </v-tooltip>
                    </div>
                    <div class="container__create-subtitle">
                      <div class="create-subtitle px-6">
                        <BaseBtn
                          @click="createSub(scope.index)"
                          type="secondary"
                          size="xsmall"
                          class="create-sub-btn"
                        >
                          <v-icon
                            size="16px"
                            class="transparent"
                            style="margin-bottom: 1px"
                          >
                            mdi-plus
                          </v-icon>
                        </BaseBtn>
                        <div class="line"></div>
                      </div>
                    </div>
                  </div>
                </template>
              </vue-virtual-table>
            </div>
          </v-col>
          <v-col class="container__player-side">
            <div class="container__timeline">
              <div class="video__container">
                <video ref="videoTag"></video>
                <div
                  class="video__progress-bar pointer"
                  @click="handleSetNewVideoTime"
                >
                  <div class="video__progress-dot"></div>
                  <div class="video__progress-bar--remaining-space"></div>
                  <div class="video__progress-seek"></div>
                </div>
              </div>
              <div class="d-flex justify-space-between py-4 px-6">
                <div class="d-flex align-center">
                  <div
                    class="d-flex align-center justify-space-between container__delay"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-on="on"
                          v-bind="attrs"
                          color="neutral-60"
                          size="16"
                          class="mr-1"
                          @click="handleDecreaseDelay"
                        >
                          mdi-chevron-left
                        </v-icon>
                      </template>
                      <span>{{
                        $t('message.pages.subtitleEditor.tooltips.delayMinus')
                      }}</span>
                    </v-tooltip>
                    <span
                      class="font-weight-regular"
                      :class="{
                        'neutral-40-light--text': !$vuetify.theme.dark,
                        'white--text': $vuetify.theme.dark,
                      }"
                      >{{ delayAmount.toFixed(1) }} s</span
                    >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-on="on"
                          v-bind="attrs"
                          color="neutral-60"
                          size="16"
                          class="mr-1"
                          @click="handleIncreaseDelay"
                        >
                          mdi-chevron-right
                        </v-icon>
                      </template>
                      <span>{{
                        $t('message.pages.subtitleEditor.tooltips.delayPlus')
                      }}</span>
                    </v-tooltip>
                  </div>
                </div>
                <div class="d-flex align-center" style="margin-left: 115px">
                  <v-icon
                    :color="$vuetify.theme.dark ? 'white' : 'neutral'"
                    class="mr-6"
                    @click="handleTogglePlayVideo"
                    @keydown.prevent
                    @keypress.prevent
                    @keyup.prevent
                    size="24px"
                  >
                    {{ videoProperties.paused ? 'panda-play' : 'mdi-pause' }}
                  </v-icon>
                  <span
                    class="text-subtitle-1 font-weight-regular"
                    :class="{
                      'neutral--text': !$vuetify.theme.dark,
                      'white--text': $vuetify.theme.dark,
                    }"
                    style="width: 95px; text-wrap: nowrap"
                    >{{
                      formatTime(
                        videoProperties.currentTime,
                        `${isLongerThanAnHour ? 'HH:' : ''}mm:ss`
                      )
                    }}:{{
                      videoProperties.currentTime.toFixed(2).slice(-2)
                    }}</span
                  >
                </div>
                <div class="d-flex align-center">
                  <v-slider
                    max="5"
                    min="1"
                    v-model="zoomRate"
                    @change="drawPreviewThumbSheet()"
                    :hide-details="true"
                    style="width: 221px"
                  >
                    <template #prepend>
                      <div class="mt-1">
                        <simple-svg
                          :src="require('@/assets/pandaIcons/zoom-out.svg')"
                          fill-class-name="fill-color"
                          fill="var(--v-neutral-40-light-base)"
                          width="16px"
                        />
                      </div>
                    </template>
                    <template #append>
                      <div class="mt-1">
                        <simple-svg
                          :src="require('@/assets/pandaIcons/zoom-in.svg')"
                          fill-class-name="fill-color"
                          fill="var(--v-neutral-40-light-base)"
                          width="16px"
                        />
                      </div>
                    </template>
                  </v-slider>
                </div>
              </div>
              <div
                class="container__images--wrapper scroll--stylized"
                ref="containerImagesWrapper"
                @wheel="handleWheelHorizontally"
              >
                <ProgressLine
                  class="progress-line"
                  ref="progressLineTimeline"
                  direction="vertical"
                />
                <div class="container__time-items"></div>
                <div class="container__subtitle-items"></div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
      <hasChangesModal @discard="handleCloseModal" />
    </template>
    <template #subtitle>
      <p
        class="text-caption mb-0"
        :class="{
          'neutral-40-light--text': !$vuetify.theme.dark,
        }"
      >
        {{ $t('message.pages.subtitleEditor.subtitle') }}
        <a
          :href="currentArticleLink"
          type="secondary"
          size="small"
          class="text-caption"
          target="_blank"
          >{{ $t('message.pages.subtitleEditor.subtitleArticle') }}
          <v-icon size="16" color="neutral-30-base">mdi-open-in-new</v-icon></a
        >
      </p>
    </template>
    <template #beforeCloseBtn>
      <v-menu
        offset-y
        left
        min-width="337px"
        nudge-bottom="4"
        content-class="shortcuts-menu"
      >
        <template v-slot:activator="{ on, attrs }">
          <BaseBtn class="mr-3" type="tertiary" v-bind="attrs" v-on="on"
            >{{ $t('message.pages.subtitleEditor.shortcuts.header') }}
            <v-icon size="20px" class="ml-2" style="height: 20px"
              >mdi-chevron-down</v-icon
            >
          </BaseBtn>
        </template>
        <v-list class="pa-0">
          <v-list-item class="d-flex justify-space-between px-4 py-3">
            <v-list-item-title class="text-caption neutral-30-base--text">{{
              $i18next.t('message.pages.subtitleEditor.shortcuts.playPause')
            }}</v-list-item-title>
            <v-list-item-subtitle class="text-end text-caption neutral-60--text"
              >Spacebar</v-list-item-subtitle
            >
          </v-list-item>

          <v-list-item class="d-flex justify-space-between px-4 py-3">
            <v-list-item-title class="text-caption neutral-30-base--text">{{
              $t('message.pages.subtitleEditor.shortcuts.forwardBackward')
            }}</v-list-item-title>
            <v-list-item-subtitle class="text-end text-caption neutral-60--text"
              >➡️ / ⬅️</v-list-item-subtitle
            >
          </v-list-item>

          <v-list-item class="d-flex justify-space-between px-4 py-3">
            <v-list-item-title class="text-caption neutral-30-base--text">{{
              $t('message.pages.subtitleEditor.shortcuts.delay')
            }}</v-list-item-title>
            <v-list-item-subtitle class="text-end text-caption neutral-60--text"
              >K / L</v-list-item-subtitle
            >
          </v-list-item>

          <v-list-item class="d-flex justify-space-between px-4 py-3">
            <v-list-item-title class="text-caption neutral-30-base--text">{{
              $t('message.pages.subtitleEditor.shortcuts.addSub')
            }}</v-list-item-title>
            <v-list-item-subtitle class="text-end text-caption neutral-60--text"
              >Shift + Enter</v-list-item-subtitle
            >
          </v-list-item>

          <v-list-item class="d-flex justify-space-between px-4 py-3">
            <v-list-item-title class="text-caption neutral-30-base--text">{{
              $t('message.pages.subtitleEditor.shortcuts.edit')
            }}</v-list-item-title>
            <v-list-item-subtitle class="text-end text-caption neutral-60--text"
              >Enter</v-list-item-subtitle
            >
          </v-list-item>
        </v-list>
      </v-menu>

      <v-tooltip bottom :disabled="hasChanges && !unmatchesSubtitles">
        <template v-slot:activator="{ on, attrs }">
          <BaseBtn
            v-on="on"
            v-bind="attrs"
            class="mr-6"
            :disabled="
              loadings.updatingSubtitle || !hasChanges || unmatchesSubtitles
            "
            :loading="loadings.updatingSubtitle"
            @click="handleUpdateSubtitle"
            >{{ $t('message.actions.publish') }}</BaseBtn
          >
        </template>
        <span>
          <template v-if="unmatchesSubtitles">
            {{
              $t('message.pages.subtitleEditor.tooltips.subtitlesAtSameTime')
            }}
          </template>
          <template v-else>
            {{ $t('message.noChanges') }}
          </template>
        </span>
      </v-tooltip>
    </template>
  </BaseModal>
</template>

<script>
import VueVirtualTable from 'vue-virtual-table-variable'
import { mapState, mapMutations } from 'vuex'
import { v4 as uuidv4 } from 'uuid'
import Hls from 'hls.js'
import { format } from 'date-fns'
import axios from 'axios'
import { WebVTTParser, WebVTTSerializer } from 'webvtt-parser'
import ProgressLine from '@/components/ProgressLine.vue'
import BaseModal from '@/components/BaseModal.vue'
import BaseBtn from '@/components/BaseBtn.vue'
import aiWorkflowMixin from '@/utils/aiWorkflow.mixin'
import hasChangesModal from '../hasChangesModal.vue'
import videosApi from '@/services/videosApi'
import Decimal from 'decimal.js'
import { mask } from 'vue-the-mask'
import _ from 'lodash'

export default {
  name: 'SubtitleContentModal',
  mixins: [aiWorkflowMixin],
  directives: { mask },
  components: {
    BaseModal,
    BaseBtn,
    ProgressLine,
    VueVirtualTable,
    hasChangesModal,
  },
  data: () => ({
    isRunningTimeUpdate: false,
    lastMouseWheelEventTime: 0,
    currentSubtitle: '',
    subtitleContent: '',
    timestampMap: '',
    iframe: null,
    videoProperties: {
      paused: true,
      currentTime: 0,
    },
    parsedSubtitle: false,
    oldParsedSubtitle: false,
    delayAmount: 0,
    clickTimeout: false,
    blockClickEvent: false,
    currentSubtitleObjectURL: '',
    loadings: {
      updatingSubtitle: false,
    },
    pixelsPerSecond: 2,
    zoomRate: 2,
    updatingSubtitleContent: false,
    isTypingMode: false,
    zoomRateList: [0.25, 0.5, 1, 1.5, 2, 2.5],
    currentLangLabel: '',
    unmatchesSubtitles: false,
  }),
  mounted() {
    this.$root.$on('SubtitleContentBeforeClose', () => {
      if (this.hasChanges) {
        this.$root.$emit('openHasChanges')
        return
      }
      this.$root.$emit('closeSubtitleContent')
    })
  },
  beforeDestroy() {
    this.handleClearClickTimeout()
    document.removeEventListener('keydown', this.handleKeyDown)
    this.$root.$off('SubtitleContentBeforeClose')
  },
  computed: {
    ...mapState({
      video: (state) => state.video.video,
      subtitles: (state) => state.video.video.config.subtitles,
      profile: (state) => state.video.profile,
    }),
    currentArticleLink() {
      const articleLinks = {
        pt: 'https://help.pandavideo.com/pt-br/article/panda-ia-legendas-automaticas-18uac9t/#1-passos-para-editar-legendas',
        en: 'https://help.pandavideo.com/en-us/article/panda-ai-automatic-subtitles-fn22w5/#1-steps-to-edit-subtitles',
        es: 'https://help.pandavideo.com/es/article/panda-ia-subtitulos-automaticos-hbd31d/#1-pasos-para-editar-subtitulos',
      }
      return articleLinks[this.$i18next.resolvedLanguage] || articleLinks.en
    },
    parsedSubtitleWithHeightProp() {
      const parsedSubs = _.cloneDeep(this.parsedSubtitle)
      return parsedSubs.map((item) => {
        item.height = 120
        return item
      })
    },
    isLongerThanAnHour() {
      if (!this.parsedSubtitle) return false
      const { endTime } = this.parsedSubtitle[this.parsedSubtitle.length - 1]
      return endTime >= 3600
    },
    tableConfig() {
      const tableConfig = [
        {
          prop: '_action',
          name: 'row',
          actionName: 'rowCommon',
          alignItems: 'start',
        },
      ]

      return tableConfig
    },
    selectedSubtitleSrcLang() {
      if (this.currentSubtitle) return this.currentSubtitle
      return false
    },
    hasChanges() {
      return !_.isEqual(this.parsedSubtitle, this.oldParsedSubtitle)
    },
  },
  watch: {
    async selectedSubtitleSrcLang(val, oldVal) {
      if (val) {
        await this.handleOpenSubtitleContent(this.selectedSubtitleSrcLang)
        if (oldVal) this.handleUpdateSubtitleContent()
      }
    },
    subtitleContent() {
      this.setSubtitleContent()
    },
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    verifyTime(item) {
      const { startTime } = item
      const id = item.metadata.id

      const hasAnySubAtSameTime = this.parsedSubtitle.some((sub) => {
        if (sub.metadata.id === id) return false
        if (startTime >= sub.startTime && startTime < sub.endTime) return true
        return false
      })
      return hasAnySubAtSameTime
    },
    verifyIfThereAreAnyUnmatchableTimes() {
      const unmatches = this.parsedSubtitle.some((sub) => {
        const result = this.verifyTime(sub)
        return result
      })
      this.unmatchesSubtitles = unmatches
    },
    removeHtmlTags(str) {
      return str.replace(/<\/?[^>]+(>|$)/g, '')
    },
    preventEnterAction(e) {
      this.isTypingMode = true
      if (e.key === 'Enter') {
        e.preventDefault()
        e.target.blur()
      }
    },
    handleCloseModal() {
      this.parsedSubtitle = _.cloneDeep(this.oldParsedSubtitle)
      this.$root.$emit('closeSubtitleContent')
    },
    convertTimeToSeconds(timeString) {
      const timeParts = timeString.split(':').reverse()

      const seconds = parseInt(timeParts[0], 10) || 0
      const minutes = parseInt(timeParts[1], 10) || 0
      const hours = parseInt(timeParts[2], 10) || 0
      const totalSeconds = seconds + minutes * 60 + hours * 3600

      return totalSeconds
    },
    handleSaveInputTimeInfo(value, field, index) {
      let seconds = this.convertTimeToSeconds(value)

      if (field === 'startTime') {
        if (
          this.parsedSubtitle[index].endTime &&
          seconds >= this.parsedSubtitle[index].endTime
        ) {
          seconds =
            this.parsedSubtitle[index].endTime - 1 ||
            this.parsedSubtitle[index].endTime
        }
      } else {
        if (seconds <= this.parsedSubtitle[index].startTime) {
          seconds = this.parsedSubtitle[index].startTime + 1
        }
      }
      this.parsedSubtitle[index][field] = seconds
      this.handleUpdateSubtitleContent()
      this.handleReRenderVttList()
      this.drawPreviewThumbSheet()
      this.verifyIfThereAreAnyUnmatchableTimes()
    },
    handleWheelHorizontally(e) {
      this.$refs.containerImagesWrapper.scrollLeft += e.deltaY
    },
    setSubtitleContent() {
      if (this.subtitleContent) {
        const lines = this.subtitleContent.split('\n')
        const timestampLine = lines.find((line) =>
          line.startsWith('X-TIMESTAMP-MAP')
        )
        this.timestampMap = timestampLine || ''

        const parser = new WebVTTParser()
        const tree = parser.parse(this.subtitleContent, 'metadata')
        this.parsedSubtitle = tree.cues
        // Set additional metadata
        this.parsedSubtitle = this.parsedSubtitle.map((item) => {
          return {
            ...item,
            metadata: {
              newText: '',
              edit: false,
              locked: true,
              fieldEdit: { index: 0, field: 'seconds' },
              id: uuidv4(),
            },
          }
        })
        this.oldParsedSubtitle = _.cloneDeep(this.parsedSubtitle)
      }
      this.verifyIfThereAreAnyUnmatchableTimes()
    },
    createSub(index) {
      let target = {
        id: '',
        startTime: 0,
        endTime: 0,
        pauseOnExit: false,
        direction: 'horizontal',
        snapToLines: true,
        linePosition: 'auto',
        lineAlign: 'start',
        textPosition: 'auto',
        positionAlign: 'auto',
        size: 100,
        alignment: 'center',
        metadata: {
          newText: '',
          edit: false,
          locked: true,
          fieldEdit: { index: 0, field: 'seconds' },
          id: uuidv4(),
        },
        text: '',
      }
      this.parsedSubtitle.splice(index + 1, 0, target)
      this.drawPreviewThumbSheet()
    },
    async handleUpdateSubtitle() {
      this.loadings.updatingSubtitle = true
      const data = new FormData()
      const newSubtitlelabel = this.langCodes.filter(
        (item) => item.srclang === this.selectedSubtitleSrcLang
      )[0].label
      const fileVtt = this.createFileForUpload()
      data.append('file', fileVtt)
      data.append('label', newSubtitlelabel)
      data.append('srclang', this.selectedSubtitleSrcLang)
      try {
        await videosApi.updateVideoSubtitleContent(this.video.id, data)

        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text: this.$i18next.t('message.changesSaved'),
          type: 'success',
        })
      } catch (e) {
        console.error(e)
      }
      this.oldParsedSubtitle = _.cloneDeep(this.parsedSubtitle)
      this.loadings.updatingSubtitle = false
    },
    updateSubtitleStyles(color, backgroundColor) {
      const styleId = 'dynamic-cue-styles'

      let styleTag = document.getElementById(styleId)

      if (!styleTag) {
        styleTag = document.createElement('style')
        styleTag.id = styleId
        document.head.appendChild(styleTag)
      }
      styleTag.textContent = `
            video::cue {
              background-color: ${backgroundColor ? backgroundColor : 'black'};
              color: ${color ? color : 'white'};
              line-height: 150%;
              font-size: 16px;
              font-family: Rubik;
            }
        `
    },
    addCustomSubtitleTrack(
      trackSrc,
      trackLabel = 'Portuguese',
      trackLang = 'pt_preview'
    ) {
      const videoElement = this.$refs.videoTag
      const track = document.createElement('track')
      track.kind = 'subtitles'
      track.label = trackLabel
      track.srclang = trackLang
      track.setAttribute('data-group-id', 'previewSubs')
      track.src = trackSrc
      track.mode = 'showing'

      videoElement.appendChild(track)
    },
    limitVideoPossibleActiveTracks() {
      this.$refs.videoTag.textTracks[0].oncuechange = function () {
        const activeCues = this.activeCues
        if (activeCues.length) {
          for (var i = 0; i < activeCues.length; i++) {
            if (i !== activeCues.length - 1) {
              activeCues[i].line = 0
              activeCues[i].position = 0
            } else {
              activeCues[i].line = 'auto'
              activeCues[i].position = 'auto'
            }
          }
        }
      }
    },
    createSubtitleUrl(subtitleContent) {
      const blob = new Blob([subtitleContent], { type: 'text/vtt' })
      const subtitleUrl = URL.createObjectURL(blob)
      return subtitleUrl
    },
    createFileForUpload() {
      this.parsedSubtitle = this.parsedSubtitle.filter((sub) =>
        Boolean(sub.text.trim().length)
      )
      const vttString = new WebVTTSerializer().serialize(this.parsedSubtitle)

      const vttContent = `WEBVTT FILE${
        this.timestampMap ? `\n${this.timestampMap}` : ''
      }${vttString.replace('WEBVTT\n', '')}`

      const blob = new Blob([vttContent], { type: 'text/vtt' })
      const file = new File([blob], 'subtitle.vtt', { type: 'text/vtt' })
      return file
    },
    sortParsedSubtitles() {
      this.parsedSubtitle.sort((a, b) => {
        if (a.startTime > b.startTime) {
          return 1
        } else if (a.startTime < b.startTime) {
          return -1
        }
        return 0
      })
      this.handleReRenderVttList()
    },
    handleBlurEditField() {
      this.blockClickEvent = true
      setTimeout(() => {
        this.blockClickEvent = false
        this.handleClearClickTimeout()
        this.sortParsedSubtitles()
        this.handleUpdateSubtitleContent()
        this.drawPreviewThumbSheet()
      }, 400)
    },
    handleClearClickTimeout() {
      clearTimeout(this.clickTimeout)
      this.clickTimeout = false
    },
    handleAddToEditField(index, fromKeyboard) {
      let item = this.parsedSubtitle[index]
      if (this.blockClickEvent) return
      const multipliers = {
        hours: 60 * 60,
        minutes: 60,
        seconds: 1,
        milliseconds: 0.1,
      }
      const multiplier = multipliers[item.metadata.fieldEdit.field]
      const fields = {
        main: item.metadata.fieldEdit.index === 1 ? 'startTime' : 'endTime',
        opposite: item.metadata.fieldEdit.index !== 1 ? 'startTime' : 'endTime',
      }

      item[fields.main] += 1 * multiplier

      if (item.metadata.locked) item[fields.opposite] += 1 * multiplier

      if (!fromKeyboard) {
        this.clickTimeout = setTimeout(
          () => this.handleAddToEditField(index),
          200
        )
      } else {
        this.handleBlurEditField()
      }
    },
    handleSubFromEditField(index, fromKeyboard) {
      let item = this.parsedSubtitle[index]
      if (this.blockClickEvent) return
      const multipliers = {
        hours: 60 * 60,
        minutes: 60,
        seconds: 1,
        milliseconds: 0.1,
      }
      const multiplier = multipliers[item.metadata.fieldEdit.field]
      const fields = {
        main: item.metadata.fieldEdit.index === 1 ? 'startTime' : 'endTime',
        opposite: item.metadata.fieldEdit.index !== 1 ? 'startTime' : 'endTime',
      }

      if (item[fields.main] - 1 * multiplier >= 0) {
        item[fields.main] -= 1 * multiplier
      } else {
        item[fields.main] = 0
      }

      if (item.metadata.locked) {
        if (item[fields.opposite] - 1 * multiplier >= 0) {
          item[fields.opposite] -= 1 * multiplier
        } else {
          item[fields.opposite] = 0
        }
      }

      if (!fromKeyboard) {
        this.clickTimeout = setTimeout(
          () => this.handleSubFromEditField(index),
          200
        )
      }
    },
    handleReRenderVttList() {
      this.parsedSubtitle = [...this.parsedSubtitle]
    },
    handleSetNewVideoTime(e) {
      const percent = e.offsetX / this.$refs.videoTag.offsetWidth
      const calc = percent * this.$refs.videoTag.duration
      this.$refs.videoTag.currentTime = calc
    },
    updateTextareaEdit(index) {
      this.isTypingMode = false
      this.parsedSubtitle[index].tree = this.getVttTreeByText(
        this.parsedSubtitle[index].text
      )
      this.handleReRenderVttList()
      this.handleUpdateSubtitleContent()
      this.drawPreviewThumbSheet()
    },
    getVttTreeByText(text) {
      const htmlContent = this.parseHTMLToObject(text)
      const vttTree = htmlContent.map((item) => {
        if (item.tag === '#text') {
          return {
            type: 'text',
            value: item.content,
          }
        } else {
          return {
            name: item.tag,
            type: 'object',
            classes: [],
            children: [
              {
                type: 'text',
                value: item.content,
              },
            ],
          }
        }
      })
      return {
        children: vttTree,
      }
    },
    parseHTMLToObject(htmlString) {
      const tempElement = document.createElement('div')
      tempElement.innerHTML = htmlString
      const result = []
      function processNodes(nodes, insideElement = false) {
        nodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) {
            const textContent = node.textContent
            if (textContent && !insideElement) {
              result.push({ tag: '#text', content: textContent })
            }
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            const tagName = node.tagName.toLowerCase()
            const innerContent = Array.from(node.childNodes)
              .filter((n) => n.nodeType === Node.TEXT_NODE)
              .map((n) => n.textContent)
              .join(' ')
            // Add the tag entry with only its own text content, not child ones
            result.push({ tag: tagName, content: innerContent })
            // Recursively process child nodes, mark as insideElement
            processNodes(node.childNodes, true)
          }
        })
      }

      processNodes(tempElement.childNodes)
      return result
    },
    strip(number) {
      return Number(parseFloat(number).toPrecision(12))
    },
    handleIncreaseDelay() {
      if (this.delayAmount < 10) {
        this.delayAmount = this.strip(this.delayAmount + 0.1)

        this.parsedSubtitle.map((item, index) => {
          const reflectedItem = this.parsedSubtitle[index]
          reflectedItem.endTime = new Decimal(reflectedItem.endTime)
            .plus(0.1)
            .toNumber()
          reflectedItem.startTime = new Decimal(reflectedItem.startTime)
            .plus(0.1)
            .toNumber()
        })
        this.handleUpdateSubtitleContent()
        this.drawPreviewThumbSheet()
      }
      this.verifyIfThereAreAnyUnmatchableTimes()
    },
    handleDecreaseDelay() {
      if (this.delayAmount - 0.1 >= 0) {
        this.delayAmount = this.strip(this.delayAmount - 0.1)

        this.parsedSubtitle.map((item, index) => {
          const reflectedItem = this.parsedSubtitle[index]
          reflectedItem.endTime = new Decimal(reflectedItem.endTime)
            .minus(0.1)
            .toNumber()
          reflectedItem.startTime = new Decimal(reflectedItem.startTime)
            .minus(0.1)
            .toNumber()
        })
        this.handleUpdateSubtitleContent()
        this.drawPreviewThumbSheet()
      }
      this.verifyIfThereAreAnyUnmatchableTimes()
    },
    deleteSubtitlePart(index) {
      this.parsedSubtitle.splice(index, 1)
      this.drawPreviewThumbSheet()
      this.handleUpdateSubtitleContent()
      // this.handleReRenderVttList()
    },
    formatTime(seconds, pattern) {
      return format(new Date(0, 0, 0, 0, 0, 0, 0).setSeconds(seconds), pattern)
    },
    setHlsPlayer() {
      this.$refs.videoTag.onended = () => {
        this.videoProperties.paused = true
      }
      this.$refs.videoTag.ontimeupdate = (data) => {
        if (this.isRunningTimeUpdate) return
        this.isRunningTimeUpdate = true
        this.activateSubtitleTrack(this.selectedSubtitleSrcLang)
        this.videoProperties.currentTime = data.target.currentTime
        this.videoProperties.duration = data.target.duration
        this.$refs.progressLineTimeline.$el.style.left = `${
          this.pixelsPerSecond * data.target.currentTime
        }px`
        if (Date.now() - this.lastMouseWheelEventTime > 2000) {
          document.querySelector('.container__images--wrapper').scrollTo({
            left: this.pixelsPerSecond * data.target.currentTime - 225,
            behavior: 'smooth',
          })
        }
        const progressBar = document.querySelector('.video__progress-dot')
        const progressBarRemain = document.querySelector(
          '.video__progress-bar--remaining-space'
        )
        const progressPos =
          this.videoProperties.currentTime / this.videoProperties.duration
        const calc = progressPos * 100
        progressBar.style.left = calc > 97.7 ? 97.7 : calc + '%'
        progressBarRemain.style.left = calc + '%'

        this.isRunningTimeUpdate = false
      }

      if (Hls.isSupported()) {
        let hls = new Hls()
        hls.testBandwidth = false
        hls.startLevel = 0
        hls.loadLevel = hls.startLevel
        hls.loadSource(this.video.video_hls)

        hls.attachMedia(this.$refs.videoTag)
        hls.on(
          Hls.Events.SUBTITLE_TRACKS_UPDATED,
          function () {
            hls.subtitleTrack = -1 // Disable original subtitles from m3u8
            this.handleUpdateSubtitleContent()
          }.bind(this)
        )
      } else if (
        this.$refs.videoTag.canPlayType('application/vnd.apple.mpegurl')
      ) {
        this.$refs.videoTag.src = this.video.video_hls
        this.$refs.videoTag.addEventListener(
          'canplay',
          function () {
            this.$refs.videoTag.pause()
          }.bind(this)
        )
      }
    },
    handleUpdateSubtitleContent() {
      this.updatingSubtitleContent = true
      const _this = this

      const content = this.parsedSubtitle
      const serializedContent = new WebVTTSerializer().serialize(content)

      if (this.currentSubtitleObjectURL)
        URL.revokeObjectURL(this.currentSubtitleObjectURL)
      this.currentSubtitleObjectURL = this.createSubtitleUrl(serializedContent)

      if (this.$refs.videoTag.firstChild) {
        while (this.$refs.videoTag.firstChild) {
          this.$refs.videoTag.removeChild(this.$refs.videoTag.firstChild)
        }
      }

      const newSubtitlelabel = this.langCodes.filter(
        (item) => item.srclang === this.selectedSubtitleSrcLang
      )[0].label

      setTimeout(async () => {
        this.updatingSubtitleContent = true
        this.addCustomSubtitleTrack(
          this.currentSubtitleObjectURL,
          newSubtitlelabel,
          `${this.selectedSubtitleSrcLang}_preview`
        )
        this.deactiveAllSubtitleTracks()
        this.limitVideoPossibleActiveTracks()
        setTimeout(() => {
          _this.activateSubtitleTrack(_this.selectedSubtitleSrcLang)
        }, 150)
      }, 100)
    },
    activateSubtitleTrack(trackLabel) {
      if (this.$refs.videoTag?.textTracks) {
        for (const track of this.$refs.videoTag.textTracks) {
          if (track.language === `${trackLabel}_preview`) {
            track.mode = 'showing'
          } else {
            track.mode = 'hidden'
          }
        }
      }
      this.updatingSubtitleContent = false
    },
    deactiveAllSubtitleTracks() {
      if (this.$refs.videoTag?.textTracks) {
        for (const track of this.$refs.videoTag.textTracks) {
          track.mode = 'hidden'
        }
      }
    },
    handleTogglePlayVideo() {
      if (this.$refs.videoTag.paused) {
        this.activateSubtitleTrack(this.selectedSubtitleSrcLang)
        this.$refs.videoTag.play()
        this.videoProperties.paused = false
      } else {
        this.$refs.videoTag.pause()
        this.videoProperties.paused = true
      }
    },
    handleForwardVideo() {
      if (this.$refs.videoTag.currentTime + 5 > this.$refs.videoTag.duration) {
        this.$refs.videoTag.currentTime +=
          this.$refs.videoTag.duration - this.$refs.videoTag.currentTime
      } else {
        this.$refs.videoTag.currentTime += 5
      }
    },
    handleBackwardVideo() {
      if (this.$refs.videoTag.currentTime >= 5) {
        this.$refs.videoTag.currentTime -= 5
      } else {
        this.$refs.videoTag.currentTime = 0
      }
    },
    handleResetClose() {
      this.isTypingMode = false
      document.removeEventListener('keydown', this.handleKeyDown)

      document.querySelector('HTML').style.overflow = 'auto'
      this.blockClickEvent = false
      this.handleClearClickTimeout()
      this.delayAmount = 0
      if (!this.$refs.videoTag.paused) this.handleTogglePlayVideo()
      this.currentSubtitle = ''
      this.subtitleContent = ''
    },
    loadImage(url) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.crossOrigin = 'anonymous'
        img.onload = () => resolve(img)
        img.onerror = reject
        img.src = url
      })
    },
    async drawPreviewThumbSheet() {
      const _this = this
      const scale = this.zoomRateList[this.zoomRate]
      const mainContainerMaxWidth = 810 * scale

      const containers = {
        subtitles: _this.$refs.containerImagesWrapper.querySelector(
          '.container__subtitle-items'
        ),
        timeItems: _this.$refs.containerImagesWrapper.querySelector(
          '.container__time-items'
        ),
      }

      while (containers.subtitles.firstChild) {
        containers.subtitles.removeChild(containers.subtitles.firstChild)
      }
      while (containers.timeItems.firstChild) {
        containers.timeItems.removeChild(containers.timeItems.firstChild)
      }

      const pixelsPerSecond = mainContainerMaxWidth / _this.video.length
      this.pixelsPerSecond = pixelsPerSecond

      for (let i = 0; i <= _this.video.length; i++) {
        if (i % 8 === 0) {
          const timeFormatted = _this.getSecondsTimeFormatted(i)

          const container = document.createElement('div')
          container.classList.add('time__stick--content')

          const timeValue = document.createElement('span')
          if (this.isLongerThanAnHour) {
            timeValue.innerHTML = `${timeFormatted[0]}:${timeFormatted[1]}:${timeFormatted[2]}`
          } else {
            timeValue.innerHTML = `${timeFormatted[1]}:${timeFormatted[2]}`
          }

          const timeValueContainer = document.createElement('div')
          timeValueContainer.classList.add('time__value--container')
          timeValueContainer.style.left = `${i !== 0 ? -38 + 21 : 0}px`
          timeValueContainer.append(timeValue)

          container.append(timeValueContainer)

          const stickElement = document.createElement('div')
          stickElement.classList.add('time__stick')
          container.append(stickElement)

          container.style.left = `${pixelsPerSecond * i}px`
          containers.timeItems.append(container)
        } else {
          const container = document.createElement('div')
          container.classList.add('time__stick')
          container.style.left = `${pixelsPerSecond * i}px`
          containers.timeItems.append(container)
        }
      }

      _this.parsedSubtitle.forEach((item) => {
        const showTime = item.endTime - item.startTime
        const width = showTime * pixelsPerSecond
        const left = item.startTime * pixelsPerSecond
        const subItem = document.createElement('div')
        subItem.style.left = `${left}px`
        subItem.style.minWidth = `${width}px`
        subItem.style.maxWidth = `${width}px`
        subItem.innerText = item.text
        subItem.setAttribute('title', item.text)
        subItem.classList.add('text-truncate')
        containers.subtitles.appendChild(subItem)
      })
    },
    handleCheckOpen(data) {
      const _this = this
      document.querySelector('HTML').style.overflow = 'hidden'
      this.currentSubtitle = data
      const item = this.availableAiLangCodes.find(
        (item) => item.srclang === data
      )
      if (item.label) this.currentLangLabel = item.label
      this.handleCheckDownloadSubContent(this.afterDownloadSubtitle)
      this.updateSubtitleStyles(
        this.profile.colors.captionsColor,
        this.profile.colors.captionsBackgroundColor
      )
      this.setShortcutEvents()
      setTimeout(() => {
        document.addEventListener('wheel', function () {
          _this.lastMouseWheelEventTime = Date.now()
        })
      }, 400)
    },
    handleKeyDown(e) {
      const _this = this
      const keyEvents = {
        KeyL: _this.handleIncreaseDelay,
        KeyK: _this.handleDecreaseDelay,
        ArrowLeft: _this.handleBackwardVideo,
        ArrowRight: _this.handleForwardVideo,
        Space: _this.handleTogglePlayVideo,
        ShiftEnter: _this.duplicateSub,
      }
      if (!this.isTypingMode) {
        if (e.code === 'Enter' && e.shiftKey) {
          keyEvents['ShiftEnter']()
        } else if (keyEvents.hasOwnProperty(e.code)) {
          if (
            (e.code === 'ArrowDown' || e.code === 'ArrowUp') &&
            (e.ctrlKey || e.shiftKey)
          ) {
            const jokerKey = e.shiftKey ? 'Shift' : 'Ctrl'
            keyEvents[`${jokerKey}${e.code}`]()
          } else if (
            (e.code === 'KeyL' || e.code === 'KeyK') &&
            this.updatingSubtitleContent
          ) {
            return
          } else {
            keyEvents[e.code]()
          }
        }
      }
    },
    setShortcutEvents() {
      document.addEventListener('keydown', this.handleKeyDown)
    },
    async afterDownloadSubtitle() {
      this.drawPreviewThumbSheet()
      this.setHlsPlayer()
    },
    async handleCheckDownloadSubContent(afterDownloadHook) {
      if (this.selectedSubtitleSrcLang) {
        await this.handleOpenSubtitleContent(this.selectedSubtitleSrcLang)
        this.setSubtitleContent()
        if (afterDownloadHook) afterDownloadHook()
      }
    },
    getSecondsFormatedAsTime(sec, isLongerThanAnHour) {
      const formatStyle = isLongerThanAnHour ? 'HH:mm:ss' : 'mm:ss'
      return format(new Date(0, 0, 0, 0, 0, sec), formatStyle)
    },
    getSecondsTimeFormatted(sec) {
      const decimal = (sec % 1) * 1000
      return [
        format(new Date(0, 0, 0, 0, 0, sec, decimal), 'HH'),
        format(new Date(0, 0, 0, 0, 0, sec, decimal), 'mm'),
        format(new Date(0, 0, 0, 0, 0, sec, decimal), 'ss'),
        format(new Date(0, 0, 0, 0, 0, sec, decimal), 'SS'),
      ]
    },
    duplicateSub() {
      const index = this.parsedSubtitle.length - 1
      let target = {
        id: '',
        startTime: Number.parseFloat(this.parsedSubtitle[index].startTime),
        endTime: Number.parseFloat(this.parsedSubtitle[index].endTime),
        pauseOnExit: false,
        direction: 'horizontal',
        snapToLines: true,
        linePosition: 'auto',
        lineAlign: 'start',
        textPosition: 'auto',
        positionAlign: 'auto',
        size: 100,
        alignment: 'center',
        metadata: {
          newText: '',
          edit: false,
          locked: true,
          fieldEdit: { index: 0, field: 'seconds' },
          id: uuidv4(),
        },
        text: '',
        tree: _.cloneDeep(this.parsedSubtitle[index].tree),
      }
      this.parsedSubtitle.splice(index + 1, 0, target)
      this.drawPreviewThumbSheet()
      setTimeout(() => {
        this.$refs.dataTableContent.$el
          .querySelector('.scroller')
          .scroll(0, 99999)
      }, 300)
    },
    async handleOpenSubtitleContent(srclang) {
      const downloadURL = this.getSubtitleDownloadLink(srclang)
      const { data: subtitleContent } = await axios.get(
        `${downloadURL}?nocache=${Date.now()}`
      )
      this.subtitleContent = subtitleContent
    },
    getSubtitleDownloadLink(srclang) {
      const isStaging = process.env.VUE_APP_ENV !== 'production'
      const downloadURL = `https://subtitles${
        isStaging ? '-staging' : ''
      }.tv.pandavideo.com.br/${this.video.pullzone_name}/${
        this.video.video_external_id
      }/${srclang}.vtt`
      return downloadURL
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/src/_ai_works';
.progress-line {
  transition: top 0.1s linear;
}

.progress-line.vertical {
  transition: left 0.11s linear;
}

.container__create-subtitle {
  width: 100%;
  position: relative;
}

.create-subtitle {
  display: none;
  position: absolute;
  justify-content: center;
  align-items: center;
  height: 24px;
  top: -12px;
  width: 100%;
  background-color: transparent !important;
  button {
    position: absolute;
    padding-left: 3px !important;
    padding-right: 3px !important;
    background: white;
  }
  .line {
    width: 100%;
    height: 1px;
    background-color: varFigma(brand-80-light);
  }
}

.subtitle-item {
  &:hover {
    @extend .selected-item;

    .create-subtitle {
      display: flex;
    }

    .delete-sub {
      visibility: visible !important;
    }
  }
}

.scroll--stylized {
  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: varFigma(neutral-80-lighter);
    border-radius: 8px;
  }
}

.v-menu {
  &__tooltip {
    box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.15);
    padding: 16px;
    background: white;

    .v-card {
      box-shadow: none;
    }
  }
}

.progress-line {
  position: absolute;
  z-index: 2;
}

.container {
  &__shortcut-key {
    border-radius: 4px;
    border: 2px solid var(--v-neutral-lighten1);
    display: flex;
    padding: 4px 12px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    width: fit-content;

    color: var(--v-neutral-lighten1);
    font-family: Rubik;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;

    i {
      color: var(--v-neutral-lighten1) !important;
      font-size: 16px;
    }
  }

  &__shortcuts {
    height: 100%;
    border-radius: 4px;
    overflow-y: auto;
    border: 1px solid #e6e8f8;
    background-color: var(--v-brand-lighten3);
    padding: 0px 16px 0px 16px;

    .header {
      position: sticky;
      top: 0px;
      background-color: var(--v-brand-lighten3);
      padding-bottom: 16px;
      padding-top: 16px;
      z-index: 2;
    }

    .list__shortcuts {
      .col {
        border-bottom: 1px solid var(--v-neutral-lighten3);
        padding-bottom: 12px;
        padding-top: 12px;

        > span {
          vertical-align: sub;
        }
      }
      .col:nth-child(odd) {
        display: flex;
        text-transform: capitalize;

        .container__shortcut-key:not(:first-child):not(i
            ~ .container__shortcut-key) {
          margin-left: 8px;
        }
      }
      .col:nth-child(1),
      .col:nth-child(2) {
        padding-top: 0;
      }
    }
  }

  &__player-side {
    min-width: 858px;
    display: flex;
    flex-direction: column;
    max-height: inherit;
  }

  &__wrapper {
    &--sub {
      max-height: inherit;
      width: 1358px;
      height: 400px;
    }
  }

  &__vtt-list {
    max-width: 500px;
    position: relative;
    height: 100%;
    overflow-y: hidden;
    border-right: 1px solid var(--v-neutral-lighten3);

    .selected-item {
      background: varFigma(neutral-background);
    }

    .lock-btn::after {
      display: none;
    }

    .lock-btn.unlocked {
      transition: none;
      transform: translateX(1.3px);
    }

    .col {
      padding: 12px 8px;
    }

    .time-content {
      align-self: center;
      width: 100%;
    }
  }

  &__time-info {
    position: relative;
  }
}

.video {
  &__container {
    position: relative;
    padding-bottom: 52%;

    video {
      position: absolute;
      width: 100%;
      top: 0px;
      height: 100%;
      background: black;
    }
  }

  &__progress-bar {
    width: 100%;
    background: #6182e6;
    height: 4px;
    position: absolute;
    bottom: -2px;
  }

  &__progress-seek {
    position: absolute;
    left: 0;
    top: 0;
    height: 4px;
    width: 100%;
    background: transparent;
    z-index: 9;
  }

  &__progress-dot {
    width: 12px;
    height: 12px;
    position: absolute;
    background: white;
    border-radius: 100%;
    left: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.9);
    z-index: 2;
  }

  &__progress-bar--remaining-space {
    position: absolute;
    left: 0;
    top: 0;
    height: 4px;
    width: -webkit-fill-available;
    background: white;
  }
}

.container__delay {
  padding: 8px;
  border-radius: 4px;
  border: 1px solid varFigma(neutral-95-lightest);
  min-width: 78px;
  font-size: 12px;
}

.time-field {
  ::v-deep fieldset {
    background-color: varFigma(neutral-100-white);
    color: varFigma(neutral-40-light);
  }
}

.time-field__selected {
  background: var(--v-brand-lighten1);
  border-bottom: 1px solid var(--v-brand-base);
  color: white !important;
  height: 21px;
}
::v-deep .selected-item .v-text-field__edit-subtitle.theme--dark {
  textarea {
    color: black !important;
  }
}
::v-deep .create-sub-btn {
  background-color: varFigma(neutral-100-white) !important;
  border-color: varFigma(brand-60) !important;

  i {
    color: varFigma(brand-60) !important;
  }
}
::v-deep .item-cell {
  display: unset !important;
  padding: 0 !important;
  border-bottom: none !important;
}
::v-deep .item-cell-inner {
  display: unset !important;
  width: 100% !important;
  height: 100% !important;
  word-break: unset !important;
  text-align: unset !important;
  overflow: unset !important;
  text-overflow: unset !important;
}
</style>

<style lang="scss">
.shortcuts-menu {
  border-radius: 4px;
  border: 1px solid varFigma(neutral-95-lightest);
  box-shadow: none;

  .v-list-item {
    height: 44px;
  }

  .v-list-item__subtitle {
    max-width: 84px;
  }
}

.time-input {
  max-width: 56px !important;
  .v-input__slot {
    padding: 0 8px !important;
    background-color: #fff !important;
  }

  &.long {
    max-width: 80px !important;
  }

  &.red-outline {
    fieldset {
      border-color: varFigma(feedback-danger) !important;
    }
  }
}

.subtitle-textarea {
  .v-input__slot {
    background-color: varFigma(neutral-100-white) !important;
  }
}
.data-table__content {
  border: none !important;
  overflow-x: hidden !important;
  .item-container {
    position: relative;
  }

  .t-container {
    height: 635px;
  }

  .scroller {
    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      border-radius: 8px;
    }

    &::-webkit-scrollbar-thumb {
      background: varFigma(neutral-80-lighter);
      border-radius: 8px;
    }
  }
}
.scroller {
  height: 400px;
}

.t-header {
  display: none;
}
canvas {
  image-rendering: optimizeSpeed; // Older versions of FF
  image-rendering: -moz-crisp-edges; // FF 6.0+
  image-rendering: -webkit-optimize-contrast; // Webkit (non standard naming)
  image-rendering: -o-crisp-edges; // OS X & Windows Opera (12.02+)
  image-rendering: crisp-edges; // Possible future browsers.
  -ms-interpolation-mode: nearest-neighbor; // IE (non standard naming)
}
.container__time-items {
  position: relative;
  height: 33px;

  div.time__stick {
    width: 1px;
    height: 8px;
    bottom: 6px;
    background: var(--v-neutral-lighten2);
    position: absolute;
  }

  div.time__stick--content {
    position: absolute;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    bottom: 0px;

    .time__value--container {
      position: absolute;
      bottom: 16px;
    }

    span {
      white-space: nowrap;
      font-family: Rubik;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%;
      color: var(--v-neutral-lighten2);

      small {
        white-space: nowrap;
        font-family: Rubik;
        font-size: 10px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%;
        color: var(--v-neutral-lighten2);
      }
    }

    .time__stick {
      width: 1px;
      height: 11px;
      background: var(--v-neutral-lighten2);
    }
  }
}

.container__subtitle-items {
  margin-top: 16px;
  margin-bottom: 3px;
  position: relative;
  height: 12px;

  div {
    position: absolute;
    width: 18px;
    height: 26px;
    border-radius: 4px;
    border: 1px solid varFigma(neutral-80-lighter);
    color: varFigma(neutral-20-dark);
    font-size: 12px;
    line-height: 150%;
    padding: 4px;
    background-color: varFigma(neutral-100-white);
    z-index: 10;
  }
}
.container__images {
  &--wrapper {
    margin-top: 8px !important;
    scroll-behavior: smooth;
    position: relative;
    margin: 0 24px;
    max-width: 100%;
    height: 86px;
    overflow-x: scroll;

    &::-webkit-scrollbar {
      height: 6px;
      width: unset;
    }

    .tile {
      display: inline-block;
      background-repeat: no-repeat;
    }
  }
}

.v-application--is-ltr
  .v-textarea.v-text-field--enclosed.v-text-field__edit-subtitle
  .v-input__slot {
  padding: 0 !important;
  padding-right: 12px !important;
}
.v-application--is-ltr
  .v-textarea.v-text-field--enclosed.v-text-field__edit-subtitle
  .v-text-field__slot
  textarea {
  padding-right: 0 !important;
  padding: 2px 12px 2px 12px !important;
  margin-top: 0 !important;

  line-height: unset;
  font-size: 12px;
}

.delete-sub {
  padding: 0 3px !important;
  margin-left: 8px;

  &.hidden {
    visibility: hidden;
  }
}
</style>
